import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import DefaultConfirmationDialog from '../Dialog/DefaultConfirmationDialog';

export default class DeleteVideo extends React.Component {

  static propTypes = {
    mediaId: PropTypes.string.isRequired,
    canDelete: PropTypes.bool,
    onDeleteVideo: PropTypes.func,
    askConfirmation: PropTypes.bool
  }

  static defaultProps = {
    canDelete: true,
    onDeleteVideo: () => {},
    askConfirmation: true
  }

  state = {
    confirmationOpen: false,
    deleting: false
  }

  mounted = false

  componentWillMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  canDelete() {
    return this.props.canDelete;
  }

  handleOpenDeleteConfirmation = () => {
    if (!this.canDelete()) {
      return;
    }

    if (this.props.askConfirmation) {
      this.setState({confirmationOpen: true});
    } else {
      this.handleDelete();
    }
  }

  handleCloseConfirmation = () => {
    if (!this.mounted) {
      return;
    }

    this.setState({
      confirmationOpen: false,
      deleting: false
    });
  }

  handleDelete = async () => {
    const {mediaId} = this.props;

    if (!this.canDelete()) {
      return;
    }

    this.setState({deleting: true});

    const promise = this.props.onDeleteVideo(mediaId);

    if (promise && promise.finally) {
      promise.finally(this.handleCloseConfirmation);
    } else {
      this.handleCloseConfirmation();
    }
  }

  render() {
    const {canDelete, askConfirmation} = this.props;
    const {confirmationOpen, deleting} = this.state;

    return (
      <React.Fragment>
        <IconButton
          onClick={this.handleOpenDeleteConfirmation}
          disabled={!canDelete}
          title={!canDelete ? I18n.t('defaults.noPermissionFunctionality') : I18n.t('action.delete')}>
          <Icon className="videoactions__delete">delete</Icon>
        </IconButton>

        {askConfirmation && (
          <DefaultConfirmationDialog
            open={confirmationOpen}
            title={I18n.t('action.deleteVideo.deleteConfirmation.title')}
            message={I18n.t('action.deleteVideo.deleteConfirmation.message')}
            onClose={this.handleCloseConfirmation}
            onConfirm={this.handleDelete}
            disabled={deleting}
          />
        )}
      </React.Fragment>
    );
  }
}
